import axios, { AxiosPromise } from 'axios';
import { IMessageViewServer } from 'store/messages/messagesSlice';
import { RootState } from 'store/store';
import { StringOrNull } from 'store/entity/types';
import {
  accessToken,
  accessTokenHeader,
  getDomainAndPort,
  userId,
} from './Utils';
import { IConversation } from 'store/conversation/conversationSlice';

const domainAndPort = getDomainAndPort();
const { protocolDomain, port } = domainAndPort;

const baseURL = `${protocolDomain}${port !== '80' ? `:${port}` : ''}/mess/rest`;
const MessApi = axios.create({
  baseURL,
  //  timeout: 125000,
});

export default MessApi;

export function conversation_getConversationList(
  state: RootState,
  maximumMessageTime: number,
  count: number
) {
  return MessApi.get('/conversation/getConversationList', {
    headers: {
      ...accessTokenHeader(state),
    },
    params: {
      ...userId(state),
      maximumMessageTime,
      count,
      ...accessToken(state),
    },
  });
}

export const getConversation = (
  state: RootState,
  conversationId: number,
  conversationToken?: StringOrNull
): AxiosPromise<IConversation> => {
  return MessApi.get('/conversation/get', {
    headers: {
      ...accessTokenHeader(state),
    },
    params: {
      conversationId,
      conversationToken,
      ...accessToken(state),
    },
  });
};

export function conversation_getMyMessages(
  state: RootState,
  messageIds: number[]
) {
  return MessApi.post('/conversation/getMyMessages', {
    messageIds,
    ...accessToken(state),
  });
}

export function conversation_getMyMessagesBefore(
  state: RootState,
  conversationId: number,
  conversationToken: StringOrNull,
  messageTime: number,
  count: number
) {
  return MessApi.get('/conversation/getMyMessagesBefore', {
    headers: {
      ...accessTokenHeader(state),
    },
    params: {
      conversationId,
      messageTime,
      count,
      conversationToken,
      ...accessToken(state),
    },
  });
}
export function sendMessage(
  state: RootState,
  messageView: IMessageViewServer,
  parseContent: boolean,
  conversationToken?: string
) {
  return MessApi.post(
    '/conversation/sendMessage',
    {
      ...messageView,
    },
    {
      headers: {
        ...accessTokenHeader(state),
      },
      params: {
        parseContent,
        ...accessToken(state),
        conversationToken,
      },
    }
  );
}

export function uploadMessageFile(
  url: string,
  file: any,
  onProgressCallback?: any
) {
  return axios.put(url, file, {
    headers: {
      'Content-Type': file.type,
    },
    onUploadProgress: (progressEvent: any): void => {
      onProgressCallback?.(progressEvent);
    },
  });
}

export function messageUploaded(
  state: RootState,
  messageId: number,
  conversationToken?: string
) {
  return MessApi.get('/conversation/uploaded', {
    headers: {
      ...accessTokenHeader(state),
    },
    params: {
      messageId,
      ...accessToken(state),
      conversationToken,
    },
  });
}

export function messageUploadCanceled(state: RootState, messageId: number) {
  return MessApi.get('/conversation/uploadCanceled', {
    headers: {
      ...accessTokenHeader(state),
    },
    params: {
      messageId,
      ...accessToken(state),
    },
  });
}

export const getMyMessagesBeforeMessage = (
  state: RootState,
  conversationId: number,
  conversationToken: StringOrNull,
  messageId: number,
  count: number,
  archived: boolean
) => {
  return MessApi.get('/conversation/getMyMessagesBeforeMessage', {
    headers: {
      ...accessTokenHeader(state),
    },
    params: {
      conversationId,
      conversationToken,
      messageId,
      count,
      archived,
      ...accessToken(state),
    },
  });
};

export const getMyMessagesAfterMessage = (
  state: RootState,
  conversationId: number,
  conversationToken: StringOrNull,
  messageId: number,
  count: number | null = null,
  archived: boolean
) => {
  return MessApi.get('/conversation/getMyMessagesAfterMessage', {
    headers: {
      ...accessTokenHeader(state),
    },
    params: {
      conversationId,
      conversationToken,
      messageId,
      count,
      archived,
      ...accessToken(state),
    },
  });
};

export function archiveMessages(
  state: RootState,
  messageIds: number[],
  archive: boolean
) {
  return MessApi.post('/conversation/archive', messageIds, {
    headers: {
      ...accessTokenHeader(state),
    },
    params: {
      archive,
      ...accessToken(state),
    },
  });
}

export function markMessagesAsRead(state: RootState, messageIds: number[]) {
  return MessApi.get('/conversation/markMessagesAsRead', {
    headers: {
      ...accessTokenHeader(state),
    },
    params: {
      messageIds,
      ...accessToken(state),
    },
  });
}

export function getConversationsByTopic(
  state: RootState,
  UserId: number,
  topic: string
) {
  return MessApi.get('/conversation/getConversationsByTopic', {
    headers: {
      ...accessTokenHeader(state),
    },
    params: {
      userId: UserId,
      topic,
      ...accessToken(state),
    },
  });
}
